import { By } from 'selenium-webdriver';
import { DriverLike, register } from '@oracle/oraclejet-webdriver';
import { FilePickerWebElement } from './FilePickerWebElement';
export { FilePickerWebElement };

/**
 * Retrieve an instance of [FilePickerWebElement](../classes/FilePickerWebElement.html).
 * @example
 * ```javascript
 * import { findFilePicker } from '@oracle/oraclejet-core-pack/webdriver';
 * const el = await findFilePicker(driver, By.id('my-oj-c-file-picker'));
 * ```
 * @param driver A WebDriver/WebElement instance from where the element will be
 * searched. If WebDriver is passed, the element will be searched globally in the
 * document. If WebElement is passed, the search will be relative to this element.
 * @param by The locator with which to find the element
 */
export async function findFilePicker(driver: DriverLike, by: By): Promise<FilePickerWebElement> {
  const webEl = await driver.findElement(by);
  // Check that the element is of type FilePickerWebElement
  if (!(webEl instanceof FilePickerWebElement)) {
    const tagName = await webEl.getTagName();
    let supplemental = '';
    if (webEl.constructor.name === 'FilePickerWebElement') {
      supplemental = 'You likely have multiple installations of this package.';
    }
    throw Error(
      `findFilePicker(${by}) created ${webEl.constructor.name} for <${tagName}>, but expected ${FilePickerWebElement.name}. ${supplemental}`
    );
  }
  return webEl;
}

register('oj-c-file-picker', FilePickerWebElement);
